import { render, staticRenderFns } from "./templateDetails.vue?vue&type=template&id=3c1df68d&scoped=true&"
import script from "./templateDetails.vue?vue&type=script&lang=js&"
export * from "./templateDetails.vue?vue&type=script&lang=js&"
import style0 from "./templateDetails.vue?vue&type=style&index=0&id=3c1df68d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c1df68d",
  null
  
)

export default component.exports